import UIText from "./UIText";
export default UIText;